import React, { useState } from 'react';
import { Sidebar } from './Sidebar';
import { Header } from './Header';
interface LayoutProps {
  children: React.ReactNode;
}
export function Layout({
  children
}: LayoutProps) {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };
  const closeSidebar = () => {
    setIsSidebarOpen(false);
  };
  return <div className="flex h-screen bg-gray-50" data-id="element-90">
      {/* Overlay for mobile */}
      {isSidebarOpen && <div className="fixed inset-0 bg-black bg-opacity-50 z-40 lg:hidden" onClick={closeSidebar} data-id="element-91" />}
      <Sidebar isOpen={isSidebarOpen} onClose={closeSidebar} data-id="element-92" />
      <div className="flex-1 flex flex-col overflow-hidden" data-id="element-93">
        <Header onMenuClick={toggleSidebar} data-id="element-94" />
        <main className="flex-1 overflow-y-auto p-6" data-id="element-95">{children}</main>
      </div>
    </div>;
}